import React from 'react'

const PT = () => {
  return (
   <section id="two">
    <div className="inner">
      <header className="major">
        <h2>Personal Training</h2>
      </header>
      <p>Nullam et orci eu lorem consequat tincidunt vivamus et sagittis libero. Mauris aliquet magna magna sed nunc rhoncus pharetra. Pellentesque condimentum sem. In efficitur ligula tate urna. Maecenas laoreet massa vel lacinia pellentesque lorem ipsum dolor. Nullam et orci eu lorem consequat tincidunt. Vivamus et sagittis libero. Mauris aliquet magna magna sed nunc rhoncus amet pharetra et feugiat tempus.</p>
      <ul className="actions">
        <li><a href="/classes" className="button next">Get Started</a></li>
      </ul>
    </div>
  </section>
  )
}

export default PT
